export const PRIKAZ10_HASH = {
  "602020214": {group: "agriculture", desc: "602020214 | Предприятие по лесоводству и лесозаготовкам"},
  "602020209": {group: "agriculture", desc: "602020209 | Предприятие пчеловодства"},
  "602020211": {group: "agriculture", desc: "602020211 | Предприятие по разведению оленей"},
  "602020207": {group: "agriculture", desc: "602020207 | Предприятие по разведению свиней"},
  "602020210": {group: "agriculture", desc: "602020210 | Предприятие по разведению кроликов и прочих пушных зверей на фермах"},
  "602020203": {group: "agriculture", desc: "602020203 | Предприятие по разведению прочих пород крупного рогатого скота и буйволов, производство спермы"},
  "602020206": {group: "agriculture", desc: "602020206 | Предприятие по разведению овец и коз"},
  "602020208": {group: "agriculture", desc: "602020208 | Предприятие по разведению сельскохозяйственной птицы"},
  "602020215": {group: "agriculture", desc: "602020215 | Предприятие по рыболовству и рыбоводству"},
  "602020204": {group: "agriculture", desc: "602020204 | Предприятие по разведению лошадей и прочих животных семейства лошадиных"},
  "602020212": {group: "agriculture", desc: "602020212 | Предприятие по разведению прочих животных"},
  "602020202": {group: "agriculture", desc: "602020202 | Предприятие по разведению молочного крупного рогатого скота, производство сырого молока"},
  "602020205": {group: "agriculture", desc: "602020205 | Предприятие по разведению верблюдов и прочих животных семейства верблюжьих"},
  "602020213": {group: "agriculture", desc: "602020213 | Предприятие смешанное - растениеводство в сочетании с животноводством без специализированного производства культур или животных"},
  "602020201": {group: "agriculture", desc: "602020201 | Предприятие растениеводства"},
  "602010801": {group: "authority_service", desc: "Административное здание"},
  "602010807": {group: "authority_service", desc: "Ветеринарная лечебница, питомник животных, кинологический центр, иной подобный объект"},
  "602010803": {group: "authority_service", desc: "Объект религиозной организации (объединения)"},
  "602010805": {group: "authority_service", desc: "Непроизводственный объект по предоставлению населению правовых, финансовых, консультационных и иных подобных услуг"},
  "602010806": {group: "authority_service", desc: "Непроизводственные объекты коммунально-бытового обслуживания и предоставления персональных услуг"},
  "602010804": {group: "authority_service", desc: "Объекты торговли, общественного питания"},
  "602010802": {group: "authority_service", desc: "Объект проведения гражданских обрядов"},
  "602010203": {group: "culture", desc: "Зрелищная организация"},
  "602010202": {group: "culture", desc: "Объект культурно-досугового (клубного) типа"},
  "602010201": {group: "culture", desc: "Объект культурно-просветительного назначения"},
  "602010106": {group: "education", desc: "Научная организация и ее структурные подразделения"},
  "602010107": {group: "education", desc: "Научные центры мирового уровня"},
  "602010105": {group: "education", desc: "Специальное учебно-воспитательное учреждение для обучающихся с девиантным (общественно опасным) поведением"},
  "602010112": {group: "education", desc: "Национальные сетевые биоресурсы"},
  "602010101": {group: "education", desc: "Дошкольная образовательная организация"},
  "602010111": {group: "education", desc: "Научная установка \"мегасайенс\""},
  "602010102": {group: "education", desc: "Общеобразовательная организация"},
  "602010104": {group: "education", desc: "Организация, реализующая программы профессионального и высшего образования"},
  "602010110": {group: "education", desc: "Центр геномных исследований мирового уровня"},
  "602010103": {group: "education", desc: "Организация дополнительного образования"},
  "602010109": {group: "education", desc: "Математический центр мирового уровня"},
  "602010108": {group: "education", desc: "Научно-образовательные центры мирового уровня"},
  "602010402": {group: "health", desc: "Лечебно-профилактическая медицинская организация, оказывающая медицинскую помощь в амбулаторных условиях и (или) в условиях дневного стационара"},
  "602010406": {group: "health", desc: "Обособленное структурное подразделение медицинской организации, оказывающей первичную медико-санитарную помощь"},
  "602010405": {group: "health", desc: "Клиники научных и научно-исследовательских организаций, организаций профессионального образования"},
  "602010401": {group: "health", desc: "Лечебно-профилактическая медицинская организация (кроме санаторно-курортной), оказывающая медицинскую помощь в стационарных условиях, ее структурное подразделение"},
  "602010408": {group: "health", desc: "Аптечная организация"},
  "602010404": {group: "health", desc: "Медицинская организация по надзору в сфере защиты прав потребителей и благополучия человека"},
  "602010403": {group: "health", desc: "Медицинская организация особого типа"},
  "602010407": {group: "health", desc: "Медицинская организация, оказывающая скорую медицинскую помощь, ее структурное подразделение"},
  "602020101": {group: "manufacturing", desc: "Предприятие добывающей промышленности (кроме угледобывающей промышленности)"},
  "602020109": {group: "manufacturing", desc: "Предприятие микробиологической, пищевой, пищевкусовой промышленности"},
  "602020108": {group: "manufacturing", desc: "Предприятие текстильной, легкой промышленности"},
  "602020106": {group: "manufacturing", desc: "Предприятие строительной промышленности, по выпуску неметаллической минеральной продукции"},
  "602020104": {group: "manufacturing", desc: "Предприятие металлургии (в том числе цветной металлургии), металлообработки"},
  "602020103": {group: "manufacturing", desc: "Предприятие химической, целлюлозно-бумажной, фармацевтической промышленности, полиграфическое предприятие"},
  "602020102": {group: "manufacturing", desc: "Предприятие нефтеперерабатывающей, коксохимической промышленности"},
  "602020107": {group: "manufacturing", desc: "Предприятие по обработке древесины, производству изделий из дерева"},
  "602020111": {group: "manufacturing", desc: "Предприятие угледобывающей промышленности"},
  "602020105": {group: "manufacturing", desc: "Предприятие машиностроения"},
  "602010903": {group: "public", desc: "Пешеходная зона"},
  "602010904": {group: "public", desc: "Благоустроенный пляж, место массовой околоводной рекреации"},
  "602010901": {group: "public", desc: "Тематический парк"},
  "602010902": {group: "public", desc: "Парк культуры и отдыха"},
  "602010601": {group: "recreation", desc: "Гостиницы и аналогичные коллективные средства размещения"},
  "602010605": {group: "recreation", desc: "Объекты физкультурно-досугового назначения и активного отдыха"},
  "602010606": {group: "recreation", desc: "Места и объекты массового посещения, в том числе тематический туризм"},
  "602010602": {group: "recreation", desc: "Специализированные коллективные средства размещения"},
  "602010604": {group: "recreation", desc: "Оздоровительно-спортивный лагерь"},
  "602010603": {group: "recreation", desc: "Детский оздоровительный лагерь"},
  "602010701": {group: "resort", desc: "Объект санаторно-курортного назначения"},
  "602010503": {group: "social", desc: "Организации (отделения) социального обслуживания на дому"},
  "602010504": {group: "social", desc: "Организации (отделения) срочного социального обслуживания, срочной социально-консультационной помощи"},
  "602010501": {group: "social", desc: "Стационарные организации социального обслуживания"},
  "602010505": {group: "social", desc: "Объекты молодежной политики"},
  "602010502": {group: "social", desc: "Комплексные, полустационарные и нестационарные организации социального обслуживани"},
  "602010301": {group: "sport", desc: "Объект спорта, включающий раздельно нормируемые спортивные сооружения (объекты) (в т.ч. физкультурно-оздоровительный комплекс)"},
  "602010302": {group: "sport", desc: "Спортивное сооружение"},
  "602031310": {group: "water_transport_obj", desc: "Речной вокзал"},
}



export const PRIKAZ10_MAPPING = {
  "602020214_рек_мз":{"width":104,"y":208,"x":1664,"height":104},
  "602020209_план_фз":{"width":136,"y":1074,"x":136,"height":136},
  "602020211_сущ_фз":{"width":136,"y":1074,"x":1496,"height":136},
  "602020214_сущ_фз":{"width":136,"y":1210,"x":1224,"height":136},
  "602020209_рек_фз":{"width":136,"y":1074,"x":272,"height":136},
  "602020207_ликв_фз":{"width":136,"y":938,"x":816,"height":136},
  "602020210_сущ_рз":{"width":118,"y":548,"x":944,"height":118},
  "602020203_рек_рз":{"width":118,"y":312,"x":1492,"height":118},
  "602020207_рек_мз":{"width":104,"y":104,"x":728,"height":104},
  "602020206_ликв_мз":{"width":104,"y":104,"x":104,"height":104},
  "602020208_план_фз":{"width":136,"y":938,"x":1496,"height":136},
  "602020203_план_рз":{"width":118,"y":312,"x":1374,"height":118},
  "602020215_рек_фз":{"width":136,"y":1210,"x":1632,"height":136},
  "602020214_ликв_мз":{"width":104,"y":208,"x":1456,"height":104},
  "602020204_ликв_фз":{"width":136,"y":802,"x":1088,"height":136},
  "602020207_сущ_фз":{"width":136,"y":938,"x":1224,"height":136},
  "602020209_план_рз":{"width":118,"y":548,"x":236,"height":118},
  "602020212_сущ_фз":{"width":136,"y":1210,"x":136,"height":136},
  "602020212_рек_фз":{"width":136,"y":1210,"x":0,"height":136},
  "602020202_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602020205_ликв_мз":{"width":104,"y":0,"x":1664,"height":104},
  "602020203_ликв_рз":{"width":118,"y":312,"x":1256,"height":118},
  "602020213_сущ_фз":{"width":136,"y":1210,"x":680,"height":136},
  "602020213_рек_рз":{"width":118,"y":666,"x":236,"height":118},
  "602020212_план_фз":{"width":136,"y":1074,"x":1768,"height":136},
  "602020211_сущ_мз":{"width":104,"y":208,"x":520,"height":104},
  "602020214_план_фз":{"width":136,"y":1210,"x":952,"height":136},
  "602020202_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602020210_ликв_мз":{"width":104,"y":104,"x":1768,"height":104},
  "602020213_ликв_мз":{"width":104,"y":208,"x":1040,"height":104},
  "602020208_ликв_мз":{"width":104,"y":104,"x":936,"height":104},
  "602020210_план_фз":{"width":136,"y":1074,"x":680,"height":136},
  "602020208_ликв_рз":{"width":118,"y":430,"x":1652,"height":118},
  "602020210_план_рз":{"width":118,"y":548,"x":708,"height":118},
  "602020212_сущ_рз":{"width":118,"y":548,"x":1888,"height":118},
  "602020209_сущ_мз":{"width":104,"y":104,"x":1664,"height":104},
  "602020215_ликв_фз":{"width":136,"y":1210,"x":1360,"height":136},
  "602020205_рек_мз":{"width":104,"y":0,"x":1872,"height":104},
  "602020215_план_рз":{"width":118,"y":666,"x":1062,"height":118},
  "602020201_план_рз":{"width":118,"y":312,"x":430,"height":118},
  "602020208_план_мз":{"width":104,"y":104,"x":1040,"height":104},
  "602020206_план_рз":{"width":118,"y":430,"x":826,"height":118},
  "602020201_сущ_рз":{"width":118,"y":312,"x":666,"height":118},
  "602020208_рек_фз":{"width":136,"y":938,"x":1632,"height":136},
  "602020202_ликв_фз":{"width":136,"y":802,"x":0,"height":136},
  "602020213_сущ_мз":{"width":104,"y":208,"x":1352,"height":104},
  "602020205_план_фз":{"width":136,"y":802,"x":1768,"height":136},
  "602020206_рек_фз":{"width":136,"y":938,"x":544,"height":136},
  "602020207_план_мз":{"width":104,"y":104,"x":624,"height":104},
  "602020204_рек_мз":{"width":104,"y":0,"x":1456,"height":104},
  "602020205_рек_фз":{"width":136,"y":938,"x":0,"height":136},
  "602020211_рек_мз":{"width":104,"y":208,"x":416,"height":104},
  "602020211_план_рз":{"width":118,"y":548,"x":1180,"height":118},
  "602020203_рек_фз":{"width":136,"y":802,"x":816,"height":136},
  "602020207_план_рз":{"width":118,"y":430,"x":1298,"height":118},
  "602020203_ликв_фз":{"width":136,"y":802,"x":544,"height":136},
  "602020202_сущ_фз":{"width":136,"y":802,"x":408,"height":136},
  "602020203_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602020201_план_фз":{"width":136,"y":666,"x":1552,"height":136},
  "602020207_рек_рз":{"width":118,"y":430,"x":1416,"height":118},
  "602020209_рек_рз":{"width":118,"y":548,"x":354,"height":118},
  "602020210_рек_мз":{"width":104,"y":208,"x":0,"height":104},
  "602020201_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602020208_сущ_мз":{"width":104,"y":104,"x":1248,"height":104},
  "602020206_рек_рз":{"width":118,"y":430,"x":944,"height":118},
  "602020207_сущ_мз":{"width":104,"y":104,"x":832,"height":104},
  "602020201_ликв_рз":{"width":118,"y":312,"x":312,"height":118},
  "602020202_рек_рз":{"width":118,"y":312,"x":1020,"height":118},
  "602020214_сущ_мз":{"width":104,"y":208,"x":1768,"height":104},
  "602020215_сущ_рз":{"width":118,"y":666,"x":1298,"height":118},
  "602020204_сущ_фз":{"width":136,"y":802,"x":1496,"height":136},
  "602020213_сущ_рз":{"width":118,"y":666,"x":354,"height":118},
  "602020203_сущ_рз":{"width":118,"y":312,"x":1610,"height":118},
  "602020207_ликв_рз":{"width":118,"y":430,"x":1180,"height":118},
  "602020210_сущ_фз":{"width":136,"y":1074,"x":952,"height":136},
  "602020209_план_мз":{"width":104,"y":104,"x":1456,"height":104},
  "602020210_план_мз":{"width":104,"y":104,"x":1872,"height":104},
  "602020206_сущ_фз":{"width":136,"y":938,"x":680,"height":136},
  "602020202_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602020209_сущ_рз":{"width":118,"y":548,"x":472,"height":118},
  "602020206_сущ_рз":{"width":118,"y":430,"x":1062,"height":118},
  "602020205_рек_рз":{"width":118,"y":430,"x":472,"height":118},
  "602020213_план_мз":{"width":104,"y":208,"x":1144,"height":104},
  "602020205_сущ_мз":{"width":104,"y":104,"x":0,"height":104},
  "602020209_ликв_мз":{"width":104,"y":104,"x":1352,"height":104},
  "602020201_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602020212_рек_мз":{"width":104,"y":208,"x":832,"height":104},
  "602020205_план_мз":{"width":104,"y":0,"x":1768,"height":104},
  "602020215_сущ_фз":{"width":136,"y":1210,"x":1768,"height":136},
  "602020202_план_рз":{"width":118,"y":312,"x":902,"height":118},
  "602020209_сущ_фз":{"width":136,"y":1074,"x":408,"height":136},
  "602020201_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602020203_рек_мз":{"width":104,"y":0,"x":1040,"height":104},
  "602020210_рек_фз":{"width":136,"y":1074,"x":816,"height":136},
  "602020204_план_мз":{"width":104,"y":0,"x":1352,"height":104},
  "602020212_сущ_мз":{"width":104,"y":208,"x":936,"height":104},
  "602020202_сущ_рз":{"width":118,"y":312,"x":1138,"height":118},
  "602020215_рек_мз":{"width":104,"y":312,"x":104,"height":104},
  "602020209_ликв_рз":{"width":118,"y":548,"x":118,"height":118},
  "602020210_ликв_рз":{"width":118,"y":548,"x":590,"height":118},
  "602020204_план_рз":{"width":118,"y":312,"x":1846,"height":118},
  "602020208_рек_мз":{"width":104,"y":104,"x":1144,"height":104},
  "602020210_ликв_фз":{"width":136,"y":1074,"x":544,"height":136},
  "602020206_ликв_фз":{"width":136,"y":938,"x":272,"height":136},
  "602020213_рек_фз":{"width":136,"y":1210,"x":544,"height":136},
  "602020210_рек_рз":{"width":118,"y":548,"x":826,"height":118},
  "602020203_сущ_фз":{"width":136,"y":802,"x":952,"height":136},
  "602020206_рек_мз":{"width":104,"y":104,"x":312,"height":104},
  "602020214_ликв_фз":{"width":136,"y":1210,"x":816,"height":136},
  "602020202_рек_фз":{"width":136,"y":802,"x":272,"height":136},
  "602020204_сущ_мз":{"width":104,"y":0,"x":1560,"height":104},
  "602020212_ликв_фз":{"width":136,"y":1074,"x":1632,"height":136},
  "602020215_план_мз":{"width":104,"y":312,"x":0,"height":104},
  "602020202_ликв_рз":{"width":118,"y":312,"x":784,"height":118},
  "602020201_ликв_фз":{"width":136,"y":666,"x":1416,"height":136},
  "602020213_план_рз":{"width":118,"y":666,"x":118,"height":118},
  "602020214_план_мз":{"width":104,"y":208,"x":1560,"height":104},
  "602020215_рек_рз":{"width":118,"y":666,"x":1180,"height":118},
  "602020204_план_фз":{"width":136,"y":802,"x":1224,"height":136},
  "602020206_сущ_мз":{"width":104,"y":104,"x":416,"height":104},
  "602020208_план_рз":{"width":118,"y":430,"x":1770,"height":118},
  "602020201_рек_рз":{"width":118,"y":312,"x":548,"height":118},
  "602020213_рек_мз":{"width":104,"y":208,"x":1248,"height":104},
  "602020208_рек_рз":{"width":118,"y":430,"x":1888,"height":118},
  "602020213_ликв_рз":{"width":118,"y":666,"x":0,"height":118},
  "602020208_сущ_фз":{"width":136,"y":938,"x":1768,"height":136},
  "602020213_ликв_фз":{"width":136,"y":1210,"x":272,"height":136},
  "602020203_план_фз":{"width":136,"y":802,"x":680,"height":136},
  "602020205_ликв_рз":{"width":118,"y":430,"x":236,"height":118},
  "602020212_план_рз":{"width":118,"y":548,"x":1652,"height":118},
  "602020205_сущ_фз":{"width":136,"y":938,"x":136,"height":136},
  "602020210_сущ_мз":{"width":104,"y":208,"x":104,"height":104},
  "602020201_сущ_фз":{"width":136,"y":666,"x":1824,"height":136},
  "602020204_рек_рз":{"width":118,"y":430,"x":0,"height":118},
  "602020206_план_мз":{"width":104,"y":104,"x":208,"height":104},
  "602020208_ликв_фз":{"width":136,"y":938,"x":1360,"height":136},
  "602020211_план_фз":{"width":136,"y":1074,"x":1224,"height":136},
  "602020205_план_рз":{"width":118,"y":430,"x":354,"height":118},
  "602020202_план_фз":{"width":136,"y":802,"x":136,"height":136},
  "602020214_план_рз":{"width":118,"y":666,"x":590,"height":118},
  "602020211_рек_рз":{"width":118,"y":548,"x":1298,"height":118},
  "602020212_ликв_мз":{"width":104,"y":208,"x":624,"height":104},
  "602020211_ликв_фз":{"width":136,"y":1074,"x":1088,"height":136},
  "602020201_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602020214_рек_фз":{"width":136,"y":1210,"x":1088,"height":136},
  "602020207_план_фз":{"width":136,"y":938,"x":952,"height":136},
  "602020212_рек_рз":{"width":118,"y":548,"x":1770,"height":118},
  "602020206_ликв_рз":{"width":118,"y":430,"x":708,"height":118},
  "602020209_ликв_фз":{"width":136,"y":1074,"x":0,"height":136},
  "602020215_сущ_мз":{"width":104,"y":312,"x":208,"height":104},
  "602020202_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602020208_сущ_рз":{"width":118,"y":548,"x":0,"height":118},
  "602020203_план_мз":{"width":104,"y":0,"x":936,"height":104},
  "602020205_сущ_рз":{"width":118,"y":430,"x":590,"height":118},
  "602020214_рек_рз":{"width":118,"y":666,"x":708,"height":118},
  "602020211_сущ_рз":{"width":118,"y":548,"x":1416,"height":118},
  "602020215_ликв_мз":{"width":104,"y":208,"x":1872,"height":104},
  "602020209_рек_мз":{"width":104,"y":104,"x":1560,"height":104},
  "602020211_рек_фз":{"width":136,"y":1074,"x":1360,"height":136},
  "602020211_ликв_рз":{"width":118,"y":548,"x":1062,"height":118},
  "602020215_план_фз":{"width":136,"y":1210,"x":1496,"height":136},
  "602020214_сущ_рз":{"width":118,"y":666,"x":826,"height":118},
  "602020213_план_фз":{"width":136,"y":1210,"x":408,"height":136},
  "602020207_сущ_рз":{"width":118,"y":430,"x":1534,"height":118},
  "602020212_ликв_рз":{"width":118,"y":548,"x":1534,"height":118},
  "602020203_сущ_мз":{"width":104,"y":0,"x":1144,"height":104},
  "602020204_ликв_мз":{"width":104,"y":0,"x":1248,"height":104},
  "602020212_план_мз":{"width":104,"y":208,"x":728,"height":104},
  "602020211_план_мз":{"width":104,"y":208,"x":312,"height":104},
  "602020205_ликв_фз":{"width":136,"y":802,"x":1632,"height":136},
  "602020204_сущ_рз":{"width":118,"y":430,"x":118,"height":118},
  "602020204_рек_фз":{"width":136,"y":802,"x":1360,"height":136},
  "602020207_рек_фз":{"width":136,"y":938,"x":1088,"height":136},
  "602020211_ликв_мз":{"width":104,"y":208,"x":208,"height":104},
  "602020215_ликв_рз":{"width":118,"y":666,"x":944,"height":118},
  "602020207_ликв_мз":{"width":104,"y":104,"x":520,"height":104},
  "602020201_рек_фз":{"width":136,"y":666,"x":1688,"height":136},
  "602020214_ликв_рз":{"width":118,"y":666,"x":472,"height":118},
  "602020206_план_фз":{"width":136,"y":938,"x":408,"height":136},
  "602020204_ликв_рз":{"width":118,"y":312,"x":1728,"height":118},
  "602010801_план_рз":{"width":118,"y":104,"x":1054,"height":118},
  "602010801_сущ_рз":{"width":118,"y":104,"x":1290,"height":118},
  "602010807_план_рз":{"width":118,"y":222,"x":1888,"height":118},
  "602010803_ликв_рз":{"width":118,"y":104,"x":1880,"height":118},
  "602010805_ликв_рз":{"width":118,"y":222,"x":826,"height":118},
  "602010803_рек_мз":{"width":104,"y":0,"x":1040,"height":104},
  "602010805_ликв_мз":{"width":104,"y":0,"x":1664,"height":104},
  "602010806_сущ_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010804_рек_фз":{"width":136,"y":476,"x":136,"height":136},
  "602010803_рек_фз":{"width":136,"y":340,"x":1596,"height":136},
  "602010804_рек_мз":{"width":104,"y":0,"x":1456,"height":104},
  "602010802_рек_рз":{"width":118,"y":104,"x":1644,"height":118},
  "602010807_рек_мз":{"width":104,"y":104,"x":728,"height":104},
  "602010807_рек_фз":{"width":136,"y":476,"x":1768,"height":136},
  "602010804_рек_рз":{"width":118,"y":222,"x":590,"height":118},
  "602010803_план_рз":{"width":118,"y":222,"x":0,"height":118},
  "602010804_ликв_мз":{"width":104,"y":0,"x":1248,"height":104},
  "602010802_план_рз":{"width":118,"y":104,"x":1526,"height":118},
  "602010802_план_фз":{"width":136,"y":340,"x":916,"height":136},
  "602010801_ликв_рз":{"width":118,"y":104,"x":936,"height":118},
  "602010806_план_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010803_план_мз":{"width":104,"y":0,"x":936,"height":104},
  "602010806_план_фз":{"width":136,"y":476,"x":1088,"height":136},
  "602010807_ликв_рз":{"width":118,"y":222,"x":1770,"height":118},
  "602010807_план_мз":{"width":104,"y":104,"x":624,"height":104},
  "602010804_план_мз":{"width":104,"y":0,"x":1352,"height":104},
  "602010807_сущ_мз":{"width":104,"y":104,"x":832,"height":104},
  "602010807_ликв_фз":{"width":136,"y":476,"x":1496,"height":136},
  "602010807_ликв_мз":{"width":104,"y":104,"x":520,"height":104},
  "602010806_рек_фз":{"width":136,"y":476,"x":1224,"height":136},
  "602010802_ликв_рз":{"width":118,"y":104,"x":1408,"height":118},
  "602010805_сущ_рз":{"width":118,"y":222,"x":1180,"height":118},
  "602010802_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010803_сущ_рз":{"width":118,"y":222,"x":236,"height":118},
  "602010807_сущ_фз":{"width":136,"y":476,"x":1904,"height":136},
  "602010803_сущ_мз":{"width":104,"y":0,"x":1144,"height":104},
  "602010807_сущ_рз":{"width":118,"y":340,"x":118,"height":118},
  "602010801_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010805_план_фз":{"width":136,"y":476,"x":544,"height":136},
  "602010803_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010806_план_рз":{"width":118,"y":222,"x":1416,"height":118},
  "602010803_рек_рз":{"width":118,"y":222,"x":118,"height":118},
  "602010805_рек_рз":{"width":118,"y":222,"x":1062,"height":118},
  "602010804_ликв_рз":{"width":118,"y":222,"x":354,"height":118},
  "602010801_рек_рз":{"width":118,"y":104,"x":1172,"height":118},
  "602010805_сущ_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010805_рек_фз":{"width":136,"y":476,"x":680,"height":136},
  "602010802_ликв_фз":{"width":136,"y":340,"x":780,"height":136},
  "602010806_сущ_рз":{"width":118,"y":222,"x":1652,"height":118},
  "602010801_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010806_ликв_рз":{"width":118,"y":222,"x":1298,"height":118},
  "602010805_план_мз":{"width":104,"y":0,"x":1768,"height":104},
  "602010805_план_рз":{"width":118,"y":222,"x":944,"height":118},
  "602010803_сущ_фз":{"width":136,"y":340,"x":1732,"height":136},
  "602010802_сущ_рз":{"width":118,"y":104,"x":1762,"height":118},
  "602010802_сущ_фз":{"width":136,"y":340,"x":1188,"height":136},
  "602010804_сущ_рз":{"width":118,"y":222,"x":708,"height":118},
  "602010804_план_рз":{"width":118,"y":222,"x":472,"height":118},
  "602010802_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010806_рек_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010804_план_фз":{"width":136,"y":476,"x":0,"height":136},
  "602010804_ликв_фз":{"width":136,"y":340,"x":1868,"height":136},
  "602010802_рек_фз":{"width":136,"y":340,"x":1052,"height":136},
  "602010807_рек_рз":{"width":118,"y":340,"x":0,"height":118},
  "602010802_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010805_рек_мз":{"width":104,"y":0,"x":1872,"height":104},
  "602010801_план_фз":{"width":136,"y":340,"x":372,"height":136},
  "602010806_ликв_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010803_план_фз":{"width":136,"y":340,"x":1460,"height":136},
  "602010804_сущ_фз":{"width":136,"y":476,"x":272,"height":136},
  "602010806_рек_рз":{"width":118,"y":222,"x":1534,"height":118},
  "602010806_сущ_фз":{"width":136,"y":476,"x":1360,"height":136},
  "602010801_рек_фз":{"width":136,"y":340,"x":508,"height":136},
  "602010801_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010801_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010801_ликв_фз":{"width":136,"y":340,"x":236,"height":136},
  "602010802_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010805_сущ_фз":{"width":136,"y":476,"x":816,"height":136},
  "602010805_ликв_фз":{"width":136,"y":476,"x":408,"height":136},
  "602010803_ликв_фз":{"width":136,"y":340,"x":1324,"height":136},
  "602010804_сущ_мз":{"width":104,"y":0,"x":1560,"height":104},
  "602010801_сущ_фз":{"width":136,"y":340,"x":644,"height":136},
  "602010807_план_фз":{"width":136,"y":476,"x":1632,"height":136},
  "602010806_ликв_фз":{"width":136,"y":476,"x":952,"height":136},
  "602010203_рек_рз":{"width":118,"y":548,"x":236,"height":118},
  "602010203_ликв_рз":{"width":118,"y":548,"x":0,"height":118},
  "602010202_план_фз":{"width":136,"y":802,"x":272,"height":136},
  "602010203_рек_мз":{"width":104,"y":208,"x":208,"height":104},
  "602010201_сущ_фз":{"width":136,"y":802,"x":0,"height":136},
  "602010203_план_рз":{"width":118,"y":548,"x":118,"height":118},
  "602010202_план_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010202_рек_фз":{"width":136,"y":938,"x":0,"height":136},
  "602010202_рек_рз":{"width":118,"y":430,"x":236,"height":118},
  "602010203_ликв_фз":{"width":136,"y":938,"x":272,"height":136},
  "602010201_план_рз":{"width":118,"y":312,"x":118,"height":118},
  "602010202_план_рз":{"width":118,"y":430,"x":118,"height":118},
  "602010203_сущ_мз":{"width":104,"y":208,"x":312,"height":104},
  "602010203_план_мз":{"width":104,"y":208,"x":104,"height":104},
  "602010201_ликв_фз":{"width":136,"y":666,"x":0,"height":136},
  "602010203_ликв_мз":{"width":104,"y":208,"x":0,"height":104},
  "602010201_план_фз":{"width":136,"y":666,"x":136,"height":136},
  "602010203_сущ_рз":{"width":118,"y":548,"x":354,"height":118},
  "602010201_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010202_сущ_фз":{"width":136,"y":938,"x":136,"height":136},
  "602010203_план_фз":{"width":136,"y":1074,"x":0,"height":136},
  "602010201_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010201_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010203_сущ_фз":{"width":136,"y":1074,"x":272,"height":136},
  "602010201_сущ_рз":{"width":118,"y":312,"x":354,"height":118},
  "602010201_рек_фз":{"width":136,"y":666,"x":272,"height":136},
  "602010202_сущ_рз":{"width":118,"y":430,"x":354,"height":118},
  "602010202_ликв_рз":{"width":118,"y":430,"x":0,"height":118},
  "602010202_сущ_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010202_рек_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010202_ликв_фз":{"width":136,"y":802,"x":136,"height":136},
  "602010201_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010201_ликв_рз":{"width":118,"y":312,"x":0,"height":118},
  "602010201_рек_рз":{"width":118,"y":312,"x":236,"height":118},
  "602010203_рек_фз":{"width":136,"y":1074,"x":136,"height":136},
  "602010202_ликв_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010106_план_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010107_план_фз":{"width":136,"y":494,"x":816,"height":136},
  "602010105_ликв_мз":{"width":104,"y":0,"x":1664,"height":104},
  "602010112_план_фз":{"width":136,"y":630,"x":1496,"height":136},
  "602010101_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010111_ликв_фз":{"width":136,"y":630,"x":816,"height":136},
  "602010102_ликв_фз":{"width":136,"y":358,"x":0,"height":136},
  "602010104_рек_фз":{"width":136,"y":358,"x":1360,"height":136},
  "602010101_сущ_рз":{"width":118,"y":104,"x":874,"height":118},
  "602010102_сущ_рз":{"width":118,"y":104,"x":1346,"height":118},
  "602010110_план_фз":{"width":136,"y":630,"x":408,"height":136},
  "602010101_план_рз":{"width":118,"y":104,"x":638,"height":118},
  "602010106_сущ_фз":{"width":136,"y":494,"x":544,"height":136},
  "602010103_сущ_фз":{"width":136,"y":358,"x":952,"height":136},
  "602010105_план_фз":{"width":136,"y":358,"x":1768,"height":136},
  "602010101_ликв_фз":{"width":136,"y":222,"x":1416,"height":136},
  "602010105_сущ_рз":{"width":118,"y":222,"x":826,"height":118},
  "602010110_сущ_фз":{"width":136,"y":630,"x":680,"height":136},
  "602010101_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010106_план_фз":{"width":136,"y":494,"x":272,"height":136},
  "602010109_сущ_фз":{"width":136,"y":630,"x":136,"height":136},
  "602010102_сущ_фз":{"width":136,"y":358,"x":408,"height":136},
  "602010108_план_фз":{"width":136,"y":494,"x":1360,"height":136},
  "602010103_рек_рз":{"width":118,"y":104,"x":1700,"height":118},
  "602010104_ликв_фз":{"width":136,"y":358,"x":1088,"height":136},
  "602010103_ликв_фз":{"width":136,"y":358,"x":544,"height":136},
  "602010101_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010102_план_рз":{"width":118,"y":104,"x":1110,"height":118},
  "602010110_рек_фз":{"width":136,"y":630,"x":544,"height":136},
  "602010107_ликв_фз":{"width":136,"y":494,"x":680,"height":136},
  "602010103_сущ_рз":{"width":118,"y":104,"x":1818,"height":118},
  "602010106_план_рз":{"width":118,"y":222,"x":1062,"height":118},
  "602010106_ликв_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010105_план_рз":{"width":118,"y":222,"x":590,"height":118},
  "602010105_план_мз":{"width":104,"y":0,"x":1768,"height":104},
  "602010102_ликв_рз":{"width":118,"y":104,"x":992,"height":118},
  "602010103_план_рз":{"width":118,"y":104,"x":1582,"height":118},
  "602010104_план_фз":{"width":136,"y":358,"x":1224,"height":136},
  "602010102_рек_фз":{"width":136,"y":358,"x":272,"height":136},
  "602010103_план_фз":{"width":136,"y":358,"x":680,"height":136},
  "602010106_рек_фз":{"width":136,"y":494,"x":408,"height":136},
  "602010108_ликв_фз":{"width":136,"y":494,"x":1224,"height":136},
  "602010102_рек_рз":{"width":118,"y":104,"x":1228,"height":118},
  "602010102_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010104_план_рз":{"width":118,"y":222,"x":118,"height":118},
  "602010104_ликв_рз":{"width":118,"y":222,"x":0,"height":118},
  "602010103_ликв_рз":{"width":118,"y":104,"x":1464,"height":118},
  "602010105_сущ_фз":{"width":136,"y":494,"x":0,"height":136},
  "602010104_план_мз":{"width":104,"y":0,"x":1352,"height":104},
  "602010109_рек_фз":{"width":136,"y":630,"x":0,"height":136},
  "602010103_сущ_мз":{"width":104,"y":0,"x":1144,"height":104},
  "602010109_план_фз":{"width":136,"y":494,"x":1904,"height":136},
  "602010106_сущ_рз":{"width":118,"y":222,"x":1298,"height":118},
  "602010110_ликв_фз":{"width":136,"y":630,"x":272,"height":136},
  "602010102_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010104_ликв_мз":{"width":104,"y":0,"x":1248,"height":104},
  "602010102_план_фз":{"width":136,"y":358,"x":136,"height":136},
  "602010107_сущ_фз":{"width":136,"y":494,"x":1088,"height":136},
  "602010109_ликв_фз":{"width":136,"y":494,"x":1768,"height":136},
  "602010102_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010101_рек_рз":{"width":118,"y":104,"x":756,"height":118},
  "602010104_сущ_мз":{"width":104,"y":0,"x":1560,"height":104},
  "602010104_рек_мз":{"width":104,"y":0,"x":1456,"height":104},
  "602010106_ликв_рз":{"width":118,"y":222,"x":944,"height":118},
  "602010112_рек_фз":{"width":136,"y":630,"x":1632,"height":136},
  "602010101_рек_фз":{"width":136,"y":222,"x":1688,"height":136},
  "602010112_сущ_фз":{"width":136,"y":630,"x":1768,"height":136},
  "602010107_рек_фз":{"width":136,"y":494,"x":952,"height":136},
  "602010111_сущ_фз":{"width":136,"y":630,"x":1224,"height":136},
  "602010105_рек_мз":{"width":104,"y":0,"x":1872,"height":104},
  "602010103_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010106_рек_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010101_сущ_фз":{"width":136,"y":222,"x":1824,"height":136},
  "602010105_ликв_рз":{"width":118,"y":222,"x":472,"height":118},
  "602010105_рек_рз":{"width":118,"y":222,"x":708,"height":118},
  "602010112_ликв_фз":{"width":136,"y":630,"x":1360,"height":136},
  "602010105_сущ_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010105_ликв_фз":{"width":136,"y":358,"x":1632,"height":136},
  "602010111_план_фз":{"width":136,"y":630,"x":952,"height":136},
  "602010108_рек_фз":{"width":136,"y":494,"x":1496,"height":136},
  "602010101_план_фз":{"width":136,"y":222,"x":1552,"height":136},
  "602010104_сущ_рз":{"width":118,"y":222,"x":354,"height":118},
  "602010101_ликв_рз":{"width":118,"y":104,"x":520,"height":118},
  "602010104_рек_рз":{"width":118,"y":222,"x":236,"height":118},
  "602010103_рек_фз":{"width":136,"y":358,"x":816,"height":136},
  "602010103_рек_мз":{"width":104,"y":0,"x":1040,"height":104},
  "602010106_сущ_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010102_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010108_сущ_фз":{"width":136,"y":494,"x":1632,"height":136},
  "602010105_рек_фз":{"width":136,"y":358,"x":1904,"height":136},
  "602010103_план_мз":{"width":104,"y":0,"x":936,"height":104},
  "602010104_сущ_фз":{"width":136,"y":358,"x":1496,"height":136},
  "602010106_ликв_фз":{"width":136,"y":494,"x":136,"height":136},
  "602010106_рек_рз":{"width":118,"y":222,"x":1180,"height":118},
  "602010101_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010111_рек_фз":{"width":136,"y":630,"x":1088,"height":136},
  "602010402_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010406_ликв_рз":{"width":118,"y":666,"x":0,"height":118},
  "602010405_сущ_фз":{"width":136,"y":1192,"x":136,"height":136},
  "602010401_рек_рз":{"width":118,"y":312,"x":756,"height":118},
  "602010408_ликв_рз":{"width":118,"y":784,"x":0,"height":118},
  "602010408_план_фз":{"width":136,"y":1328,"x":544,"height":136},
  "602010404_сущ_рз":{"width":118,"y":548,"x":354,"height":118},
  "602010406_рек_мз":{"width":104,"y":208,"x":416,"height":104},
  "602010403_план_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010403_рек_фз":{"width":136,"y":920,"x":816,"height":136},
  "602010403_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010401_сущ_фз":{"width":136,"y":784,"x":880,"height":136},
  "602010408_план_рз":{"width":118,"y":784,"x":118,"height":118},
  "602010408_рек_мз":{"width":104,"y":312,"x":312,"height":104},
  "602010401_рек_фз":{"width":136,"y":784,"x":744,"height":136},
  "602010401_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010408_сущ_фз":{"width":136,"y":1328,"x":816,"height":136},
  "602010402_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010402_план_рз":{"width":118,"y":430,"x":118,"height":118},
  "602010402_рек_рз":{"width":118,"y":430,"x":236,"height":118},
  "602010405_план_рз":{"width":118,"y":548,"x":590,"height":118},
  "602010407_ликв_фз":{"width":136,"y":1192,"x":816,"height":136},
  "602010407_рек_рз":{"width":118,"y":666,"x":708,"height":118},
  "602010405_ликв_фз":{"width":136,"y":1056,"x":680,"height":136},
  "602010404_ликв_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010407_рек_мз":{"width":104,"y":208,"x":832,"height":104},
  "602010402_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010406_план_фз":{"width":136,"y":1192,"x":408,"height":136},
  "602010408_сущ_мз":{"width":104,"y":312,"x":416,"height":104},
  "602010407_сущ_рз":{"width":118,"y":666,"x":826,"height":118},
  "602010402_ликв_фз":{"width":136,"y":920,"x":0,"height":136},
  "602010402_рек_фз":{"width":136,"y":920,"x":272,"height":136},
  "602010401_план_фз":{"width":136,"y":784,"x":608,"height":136},
  "602010405_план_мз":{"width":104,"y":104,"x":832,"height":104},
  "602010402_сущ_фз":{"width":136,"y":920,"x":408,"height":136},
  "602010402_сущ_рз":{"width":118,"y":430,"x":354,"height":118},
  "602010403_ликв_фз":{"width":136,"y":920,"x":544,"height":136},
  "602010403_план_фз":{"width":136,"y":920,"x":680,"height":136},
  "602010406_план_рз":{"width":118,"y":666,"x":118,"height":118},
  "602010402_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010404_сущ_фз":{"width":136,"y":1056,"x":544,"height":136},
  "602010402_ликв_рз":{"width":118,"y":430,"x":0,"height":118},
  "602010407_план_рз":{"width":118,"y":666,"x":590,"height":118},
  "602010407_сущ_фз":{"width":136,"y":1328,"x":272,"height":136},
  "602010406_рек_фз":{"width":136,"y":1192,"x":544,"height":136},
  "602010406_сущ_рз":{"width":118,"y":666,"x":354,"height":118},
  "602010404_сущ_мз":{"width":104,"y":104,"x":624,"height":104},
  "602010405_план_фз":{"width":136,"y":1056,"x":816,"height":136},
  "602010405_рек_рз":{"width":118,"y":548,"x":708,"height":118},
  "602010404_рек_мз":{"width":104,"y":104,"x":520,"height":104},
  "602010401_ликв_фз":{"width":136,"y":784,"x":472,"height":136},
  "602010403_сущ_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010407_план_фз":{"width":136,"y":1328,"x":0,"height":136},
  "602010408_рек_рз":{"width":118,"y":784,"x":236,"height":118},
  "602010405_рек_фз":{"width":136,"y":1192,"x":0,"height":136},
  "602010403_рек_рз":{"width":118,"y":430,"x":708,"height":118},
  "602010408_ликв_фз":{"width":136,"y":1328,"x":408,"height":136},
  "602010403_сущ_фз":{"width":136,"y":1056,"x":0,"height":136},
  "602010401_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010403_ликв_рз":{"width":118,"y":430,"x":472,"height":118},
  "602010403_рек_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010404_ликв_рз":{"width":118,"y":548,"x":0,"height":118},
  "602010405_рек_мз":{"width":104,"y":208,"x":0,"height":104},
  "602010406_сущ_фз":{"width":136,"y":1192,"x":680,"height":136},
  "602010402_план_фз":{"width":136,"y":920,"x":136,"height":136},
  "602010401_ликв_рз":{"width":118,"y":312,"x":520,"height":118},
  "602010404_план_рз":{"width":118,"y":548,"x":118,"height":118},
  "602010405_сущ_мз":{"width":104,"y":208,"x":104,"height":104},
  "602010408_сущ_рз":{"width":118,"y":784,"x":354,"height":118},
  "602010406_рек_рз":{"width":118,"y":666,"x":236,"height":118},
  "602010405_ликв_рз":{"width":118,"y":548,"x":472,"height":118},
  "602010407_план_мз":{"width":104,"y":208,"x":728,"height":104},
  "602010404_рек_рз":{"width":118,"y":548,"x":236,"height":118},
  "602010403_сущ_рз":{"width":118,"y":430,"x":826,"height":118},
  "602010404_ликв_фз":{"width":136,"y":1056,"x":136,"height":136},
  "602010404_рек_фз":{"width":136,"y":1056,"x":408,"height":136},
  "602010404_план_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010406_сущ_мз":{"width":104,"y":208,"x":520,"height":104},
  "602010407_сущ_мз":{"width":104,"y":312,"x":0,"height":104},
  "602010408_рек_фз":{"width":136,"y":1328,"x":680,"height":136},
  "602010406_план_мз":{"width":104,"y":208,"x":312,"height":104},
  "602010404_план_фз":{"width":136,"y":1056,"x":272,"height":136},
  "602010405_сущ_рз":{"width":118,"y":548,"x":826,"height":118},
  "602010407_ликв_мз":{"width":104,"y":208,"x":624,"height":104},
  "602010403_план_рз":{"width":118,"y":430,"x":590,"height":118},
  "602010401_план_рз":{"width":118,"y":312,"x":638,"height":118},
  "602010408_план_мз":{"width":104,"y":312,"x":208,"height":104},
  "602010401_сущ_рз":{"width":118,"y":312,"x":874,"height":118},
  "602010406_ликв_мз":{"width":104,"y":208,"x":208,"height":104},
  "602010401_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010401_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010405_ликв_мз":{"width":104,"y":104,"x":728,"height":104},
  "602010406_ликв_фз":{"width":136,"y":1192,"x":272,"height":136},
  "602010407_ликв_рз":{"width":118,"y":666,"x":472,"height":118},
  "602010407_рек_фз":{"width":136,"y":1328,"x":136,"height":136},
  "602010408_ликв_мз":{"width":104,"y":312,"x":104,"height":104},
  "602020101_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602020109_ликв_рз":{"width":118,"y":888,"x":472,"height":118},
  "602020101_ликв_фз":{"width":136,"y":1006,"x":472,"height":136},
  "602020108_рек_мз":{"width":104,"y":312,"x":312,"height":104},
  "602020106_рек_мз":{"width":104,"y":208,"x":416,"height":104},
  "602020106_рек_рз":{"width":118,"y":770,"x":236,"height":118},
  "602020106_рек_фз":{"width":136,"y":1414,"x":680,"height":136},
  "602020104_ликв_мз":{"width":104,"y":104,"x":312,"height":104},
  "602020103_ликв_фз":{"width":136,"y":1142,"x":680,"height":136},
  "602020101_рек_фз":{"width":136,"y":1006,"x":744,"height":136},
  "602020109_рек_фз":{"width":136,"y":1686,"x":408,"height":136},
  "602020103_сущ_мз":{"width":104,"y":104,"x":208,"height":104},
  "602020104_план_рз":{"width":118,"y":652,"x":118,"height":118},
  "602020102_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602020103_сущ_рз":{"width":118,"y":534,"x":826,"height":118},
  "602020104_план_мз":{"width":104,"y":104,"x":416,"height":104},
  "602020109_рек_мз":{"width":104,"y":312,"x":728,"height":104},
  "602020107_сущ_мз":{"width":104,"y":312,"x":0,"height":104},
  "602020102_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602020111_рек_фз":{"width":136,"y":1822,"x":0,"height":136},
  "602020106_план_фз":{"width":136,"y":1414,"x":544,"height":136},
  "602020111_ликв_рз":{"width":118,"y":1006,"x":0,"height":118},
  "602020103_рек_фз":{"width":136,"y":1278,"x":0,"height":136},
  "602020102_ликв_фз":{"width":136,"y":1142,"x":136,"height":136},
  "602020107_сущ_фз":{"width":136,"y":1550,"x":408,"height":136},
  "602020105_ликв_рз":{"width":118,"y":652,"x":472,"height":118},
  "602020108_план_рз":{"width":118,"y":888,"x":118,"height":118},
  "602020105_ликв_мз":{"width":104,"y":104,"x":728,"height":104},
  "602020109_ликв_фз":{"width":136,"y":1686,"x":136,"height":136},
  "602020109_рек_рз":{"width":118,"y":888,"x":708,"height":118},
  "602020104_рек_рз":{"width":118,"y":652,"x":236,"height":118},
  "602020104_рек_фз":{"width":136,"y":1278,"x":544,"height":136},
  "602020108_план_мз":{"width":104,"y":312,"x":208,"height":104},
  "602020106_ликв_фз":{"width":136,"y":1414,"x":408,"height":136},
  "602020101_сущ_рз":{"width":118,"y":416,"x":770,"height":118},
  "602020106_план_мз":{"width":104,"y":208,"x":312,"height":104},
  "602020109_план_фз":{"width":136,"y":1686,"x":272,"height":136},
  "602020111_рек_рз":{"width":118,"y":1006,"x":236,"height":118},
  "602020109_план_рз":{"width":118,"y":888,"x":590,"height":118},
  "602020105_план_фз":{"width":136,"y":1414,"x":0,"height":136},
  "602020105_ликв_фз":{"width":136,"y":1278,"x":816,"height":136},
  "602020111_план_фз":{"width":136,"y":1686,"x":816,"height":136},
  "602020105_рек_мз":{"width":104,"y":208,"x":0,"height":104},
  "602020105_рек_фз":{"width":136,"y":1414,"x":136,"height":136},
  "602020101_ликв_рз":{"width":118,"y":416,"x":416,"height":118},
  "602020104_сущ_рз":{"width":118,"y":652,"x":354,"height":118},
  "602020108_ликв_фз":{"width":136,"y":1550,"x":544,"height":136},
  "602020107_рек_мз":{"width":104,"y":208,"x":832,"height":104},
  "602020105_план_мз":{"width":104,"y":104,"x":832,"height":104},
  "602020104_план_фз":{"width":136,"y":1278,"x":408,"height":136},
  "602020101_план_рз":{"width":118,"y":416,"x":534,"height":118},
  "602020108_план_фз":{"width":136,"y":1550,"x":680,"height":136},
  "602020102_рек_фз":{"width":136,"y":1142,"x":408,"height":136},
  "602020107_план_фз":{"width":136,"y":1550,"x":136,"height":136},
  "602020111_ликв_фз":{"width":136,"y":1686,"x":680,"height":136},
  "602020107_ликв_рз":{"width":118,"y":770,"x":472,"height":118},
  "602020107_ликв_мз":{"width":104,"y":208,"x":624,"height":104},
  "602020111_сущ_фз":{"width":136,"y":1822,"x":136,"height":136},
  "602020108_ликв_мз":{"width":104,"y":312,"x":104,"height":104},
  "602020108_рек_рз":{"width":118,"y":888,"x":236,"height":118},
  "602020103_рек_рз":{"width":118,"y":534,"x":708,"height":118},
  "602020109_сущ_фз":{"width":136,"y":1686,"x":544,"height":136},
  "602020102_сущ_фз":{"width":136,"y":1142,"x":544,"height":136},
  "602020108_сущ_мз":{"width":104,"y":312,"x":416,"height":104},
  "602020104_сущ_мз":{"width":104,"y":104,"x":624,"height":104},
  "602020106_ликв_мз":{"width":104,"y":208,"x":208,"height":104},
  "602020111_сущ_мз":{"width":104,"y":416,"x":312,"height":104},
  "602020108_ликв_рз":{"width":118,"y":888,"x":0,"height":118},
  "602020105_сущ_мз":{"width":104,"y":208,"x":104,"height":104},
  "602020102_план_фз":{"width":136,"y":1142,"x":272,"height":136},
  "602020111_план_рз":{"width":118,"y":1006,"x":118,"height":118},
  "602020102_сущ_рз":{"width":118,"y":534,"x":354,"height":118},
  "602020111_план_мз":{"width":104,"y":416,"x":104,"height":104},
  "602020101_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602020107_сущ_рз":{"width":118,"y":770,"x":826,"height":118},
  "602020107_рек_фз":{"width":136,"y":1550,"x":272,"height":136},
  "602020107_план_мз":{"width":104,"y":208,"x":728,"height":104},
  "602020103_план_рз":{"width":118,"y":534,"x":590,"height":118},
  "602020101_план_фз":{"width":136,"y":1006,"x":608,"height":136},
  "602020103_план_фз":{"width":136,"y":1142,"x":816,"height":136},
  "602020108_сущ_фз":{"width":136,"y":1686,"x":0,"height":136},
  "602020106_сущ_фз":{"width":136,"y":1414,"x":816,"height":136},
  "602020104_ликв_фз":{"width":136,"y":1278,"x":272,"height":136},
  "602020103_рек_мз":{"width":104,"y":104,"x":104,"height":104},
  "602020102_план_рз":{"width":118,"y":534,"x":118,"height":118},
  "602020105_план_рз":{"width":118,"y":652,"x":590,"height":118},
  "602020104_сущ_фз":{"width":136,"y":1278,"x":680,"height":136},
  "602020102_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602020106_ликв_рз":{"width":118,"y":770,"x":0,"height":118},
  "602020106_план_рз":{"width":118,"y":770,"x":118,"height":118},
  "602020102_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602020102_рек_рз":{"width":118,"y":534,"x":236,"height":118},
  "602020107_ликв_фз":{"width":136,"y":1550,"x":0,"height":136},
  "602020109_ликв_мз":{"width":104,"y":312,"x":520,"height":104},
  "602020111_сущ_рз":{"width":118,"y":1006,"x":354,"height":118},
  "602020104_рек_мз":{"width":104,"y":104,"x":520,"height":104},
  "602020108_рек_фз":{"width":136,"y":1550,"x":816,"height":136},
  "602020109_сущ_рз":{"width":118,"y":888,"x":826,"height":118},
  "602020103_ликв_рз":{"width":118,"y":534,"x":472,"height":118},
  "602020105_рек_рз":{"width":118,"y":652,"x":708,"height":118},
  "602020111_рек_мз":{"width":104,"y":416,"x":208,"height":104},
  "602020107_рек_рз":{"width":118,"y":770,"x":708,"height":118},
  "602020109_план_мз":{"width":104,"y":312,"x":624,"height":104},
  "602020103_план_мз":{"width":104,"y":104,"x":0,"height":104},
  "602020105_сущ_фз":{"width":136,"y":1414,"x":272,"height":136},
  "602020106_сущ_мз":{"width":104,"y":208,"x":520,"height":104},
  "602020101_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602020101_сущ_фз":{"width":136,"y":1142,"x":0,"height":136},
  "602020108_сущ_рз":{"width":118,"y":888,"x":354,"height":118},
  "602020111_ликв_мз":{"width":104,"y":416,"x":0,"height":104},
  "602020103_сущ_фз":{"width":136,"y":1278,"x":136,"height":136},
  "602020105_сущ_рз":{"width":118,"y":652,"x":826,"height":118},
  "602020101_рек_рз":{"width":118,"y":416,"x":652,"height":118},
  "602020107_план_рз":{"width":118,"y":770,"x":590,"height":118},
  "602020109_сущ_мз":{"width":104,"y":312,"x":832,"height":104},
  "602020101_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602020104_ликв_рз":{"width":118,"y":652,"x":0,"height":118},
  "602020103_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602020102_ликв_рз":{"width":118,"y":534,"x":0,"height":118},
  "602020106_сущ_рз":{"width":118,"y":770,"x":354,"height":118},
  "602010903_план_фз":{"width":136,"y":612,"x":0,"height":136},
  "602010904_план_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010901_рек_рз":{"width":118,"y":222,"x":0,"height":118},
  "602010901_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010904_план_рз":{"width":118,"y":340,"x":354,"height":118},
  "602010904_сущ_мз":{"width":104,"y":104,"x":624,"height":104},
  "602010904_ликв_фз":{"width":136,"y":612,"x":408,"height":136},
  "602010901_ликв_фз":{"width":136,"y":340,"x":708,"height":136},
  "602010902_план_рз":{"width":118,"y":222,"x":354,"height":118},
  "602010901_сущ_рз":{"width":118,"y":222,"x":118,"height":118},
  "602010902_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010904_рек_фз":{"width":136,"y":612,"x":680,"height":136},
  "602010902_сущ_рз":{"width":118,"y":222,"x":590,"height":118},
  "602010903_рек_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010902_рек_фз":{"width":136,"y":476,"x":544,"height":136},
  "602010903_ликв_фз":{"width":136,"y":476,"x":816,"height":136},
  "602010903_рек_фз":{"width":136,"y":612,"x":136,"height":136},
  "602010901_план_рз":{"width":118,"y":104,"x":846,"height":118},
  "602010903_план_рз":{"width":118,"y":222,"x":826,"height":118},
  "602010901_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010901_план_фз":{"width":136,"y":340,"x":844,"height":136},
  "602010902_план_фз":{"width":136,"y":476,"x":408,"height":136},
  "602010901_рек_фз":{"width":136,"y":476,"x":0,"height":136},
  "602010902_рек_рз":{"width":118,"y":222,"x":472,"height":118},
  "602010904_сущ_рз":{"width":118,"y":340,"x":590,"height":118},
  "602010902_ликв_фз":{"width":136,"y":476,"x":272,"height":136},
  "602010902_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010901_сущ_фз":{"width":136,"y":476,"x":136,"height":136},
  "602010904_рек_мз":{"width":104,"y":104,"x":520,"height":104},
  "602010904_ликв_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010903_план_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010901_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010903_сущ_фз":{"width":136,"y":612,"x":272,"height":136},
  "602010901_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010904_рек_рз":{"width":118,"y":340,"x":472,"height":118},
  "602010902_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010903_сущ_рз":{"width":118,"y":340,"x":118,"height":118},
  "602010903_сущ_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010903_рек_рз":{"width":118,"y":340,"x":0,"height":118},
  "602010904_ликв_рз":{"width":118,"y":340,"x":236,"height":118},
  "602010904_сущ_фз":{"width":136,"y":612,"x":816,"height":136},
  "602010902_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010904_план_фз":{"width":136,"y":612,"x":544,"height":136},
  "602010903_ликв_рз":{"width":118,"y":222,"x":708,"height":118},
  "602010901_ликв_рз":{"width":118,"y":104,"x":728,"height":118},
  "602010903_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010902_сущ_фз":{"width":136,"y":476,"x":680,"height":136},
  "602010902_ликв_рз":{"width":118,"y":222,"x":236,"height":118},
  "602010601_рек_фз":{"width":136,"y":562,"x":862,"height":136},
  "602010605_рек_фз":{"width":136,"y":970,"x":136,"height":136},
  "602010606_рек_фз":{"width":136,"y":970,"x":680,"height":136},
  "602010605_сущ_мз":{"width":104,"y":208,"x":104,"height":104},
  "602010602_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010605_рек_рз":{"width":118,"y":444,"x":826,"height":118},
  "602010604_план_фз":{"width":136,"y":834,"x":408,"height":136},
  "602010603_ликв_фз":{"width":136,"y":698,"x":680,"height":136},
  "602010602_ликв_фз":{"width":136,"y":698,"x":136,"height":136},
  "602010606_план_фз":{"width":136,"y":970,"x":544,"height":136},
  "602010603_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010605_ликв_мз":{"width":104,"y":104,"x":728,"height":104},
  "602010601_ликв_фз":{"width":136,"y":562,"x":590,"height":136},
  "602010604_сущ_фз":{"width":136,"y":834,"x":680,"height":136},
  "602010604_план_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010605_рек_мз":{"width":104,"y":208,"x":0,"height":104},
  "602010601_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010604_сущ_рз":{"width":118,"y":444,"x":472,"height":118},
  "602010605_сущ_рз":{"width":118,"y":562,"x":0,"height":118},
  "602010606_план_мз":{"width":104,"y":208,"x":312,"height":104},
  "602010602_план_рз":{"width":118,"y":326,"x":236,"height":118},
  "602010603_ликв_рз":{"width":118,"y":326,"x":590,"height":118},
  "602010604_план_рз":{"width":118,"y":444,"x":236,"height":118},
  "602010602_сущ_рз":{"width":118,"y":326,"x":472,"height":118},
  "602010602_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010601_сущ_фз":{"width":136,"y":698,"x":0,"height":136},
  "602010604_ликв_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010603_сущ_рз":{"width":118,"y":444,"x":0,"height":118},
  "602010601_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010606_сущ_фз":{"width":136,"y":970,"x":816,"height":136},
  "602010604_сущ_мз":{"width":104,"y":104,"x":624,"height":104},
  "602010602_ликв_рз":{"width":118,"y":326,"x":118,"height":118},
  "602010603_план_рз":{"width":118,"y":326,"x":708,"height":118},
  "602010602_рек_рз":{"width":118,"y":326,"x":354,"height":118},
  "602010605_план_рз":{"width":118,"y":444,"x":708,"height":118},
  "602010602_рек_фз":{"width":136,"y":698,"x":408,"height":136},
  "602010603_сущ_фз":{"width":136,"y":834,"x":136,"height":136},
  "602010603_план_фз":{"width":136,"y":698,"x":816,"height":136},
  "602010606_сущ_мз":{"width":104,"y":208,"x":520,"height":104},
  "602010606_план_рз":{"width":118,"y":562,"x":236,"height":118},
  "602010602_план_фз":{"width":136,"y":698,"x":272,"height":136},
  "602010605_ликв_рз":{"width":118,"y":444,"x":590,"height":118},
  "602010602_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010604_рек_рз":{"width":118,"y":444,"x":354,"height":118},
  "602010601_сущ_рз":{"width":118,"y":326,"x":0,"height":118},
  "602010604_рек_фз":{"width":136,"y":834,"x":544,"height":136},
  "602010606_рек_рз":{"width":118,"y":562,"x":354,"height":118},
  "602010602_сущ_фз":{"width":136,"y":698,"x":544,"height":136},
  "602010601_ликв_рз":{"width":118,"y":208,"x":624,"height":118},
  "602010601_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010601_рек_рз":{"width":118,"y":208,"x":860,"height":118},
  "602010603_рек_фз":{"width":136,"y":834,"x":0,"height":136},
  "602010604_ликв_рз":{"width":118,"y":444,"x":118,"height":118},
  "602010605_ликв_фз":{"width":136,"y":834,"x":816,"height":136},
  "602010606_сущ_рз":{"width":118,"y":562,"x":472,"height":118},
  "602010603_рек_рз":{"width":118,"y":326,"x":826,"height":118},
  "602010606_рек_мз":{"width":104,"y":208,"x":416,"height":104},
  "602010604_ликв_фз":{"width":136,"y":834,"x":272,"height":136},
  "602010601_план_рз":{"width":118,"y":208,"x":742,"height":118},
  "602010605_план_мз":{"width":104,"y":104,"x":832,"height":104},
  "602010603_сущ_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010604_рек_мз":{"width":104,"y":104,"x":520,"height":104},
  "602010606_ликв_рз":{"width":118,"y":562,"x":118,"height":118},
  "602010601_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010606_ликв_фз":{"width":136,"y":970,"x":408,"height":136},
  "602010605_план_фз":{"width":136,"y":970,"x":0,"height":136},
  "602010601_план_фз":{"width":136,"y":562,"x":726,"height":136},
  "602010605_сущ_фз":{"width":136,"y":970,"x":272,"height":136},
  "602010606_ликв_мз":{"width":104,"y":208,"x":208,"height":104},
  "602010603_рек_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010602_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010603_план_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010701_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010701_ликв_рз":{"width":118,"y":0,"x":104,"height":118},
  "602010701_ликв_фз":{"width":136,"y":118,"x":0,"height":136},
  "602010701_план_мз":{"width":104,"y":118,"x":136,"height":104},
  "602010701_план_рз":{"width":118,"y":254,"x":0,"height":118},
  "602010701_план_фз":{"width":136,"y":254,"x":118,"height":136},
  "602010701_рек_мз":{"width":104,"y":390,"x":0,"height":104},
  "602010701_рек_рз":{"width":118,"y":390,"x":104,"height":118},
  "602010701_рек_фз":{"width":136,"y":508,"x":0,"height":136},
  "602010701_сущ_мз":{"width":104,"y":508,"x":136,"height":104},
  "602010701_сущ_рз":{"width":118,"y":644,"x":0,"height":118},
  "602010701_сущ_фз":{"width":136,"y":644,"x":118,"height":136},
  "602010503_рек_рз":{"width":118,"y":326,"x":472,"height":118},
  "602010504_сущ_мз":{"width":104,"y":104,"x":624,"height":104},
  "602010501_сущ_фз":{"width":136,"y":580,"x":272,"height":136},
  "602010505_ликв_рз":{"width":118,"y":444,"x":236,"height":118},
  "602010505_сущ_фз":{"width":136,"y":852,"x":544,"height":136},
  "602010503_сущ_фз":{"width":136,"y":716,"x":408,"height":136},
  "602010503_план_рз":{"width":118,"y":326,"x":354,"height":118},
  "602010504_сущ_фз":{"width":136,"y":852,"x":0,"height":136},
  "602010503_ликв_мз":{"width":104,"y":0,"x":832,"height":104},
  "602010502_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010504_ликв_рз":{"width":118,"y":326,"x":708,"height":118},
  "602010501_ликв_фз":{"width":136,"y":444,"x":708,"height":136},
  "602010501_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010501_план_фз":{"width":136,"y":580,"x":0,"height":136},
  "602010504_рек_рз":{"width":118,"y":444,"x":0,"height":118},
  "602010504_план_рз":{"width":118,"y":326,"x":826,"height":118},
  "602010501_план_рз":{"width":118,"y":208,"x":326,"height":118},
  "602010505_план_рз":{"width":118,"y":444,"x":354,"height":118},
  "602010501_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010505_план_мз":{"width":104,"y":104,"x":832,"height":104},
  "602010501_сущ_рз":{"width":118,"y":208,"x":562,"height":118},
  "602010502_рек_рз":{"width":118,"y":326,"x":0,"height":118},
  "602010501_рек_рз":{"width":118,"y":208,"x":444,"height":118},
  "602010502_план_рз":{"width":118,"y":208,"x":798,"height":118},
  "602010505_план_фз":{"width":136,"y":852,"x":272,"height":136},
  "602010502_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010502_сущ_фз":{"width":136,"y":580,"x":816,"height":136},
  "602010502_ликв_фз":{"width":136,"y":580,"x":408,"height":136},
  "602010505_рек_рз":{"width":118,"y":444,"x":472,"height":118},
  "602010505_ликв_фз":{"width":136,"y":852,"x":136,"height":136},
  "602010504_план_мз":{"width":104,"y":104,"x":416,"height":104},
  "602010504_сущ_рз":{"width":118,"y":444,"x":118,"height":118},
  "602010504_рек_мз":{"width":104,"y":104,"x":520,"height":104},
  "602010505_ликв_мз":{"width":104,"y":104,"x":728,"height":104},
  "602010505_сущ_рз":{"width":118,"y":444,"x":590,"height":118},
  "602010501_рек_фз":{"width":136,"y":580,"x":136,"height":136},
  "602010502_рек_фз":{"width":136,"y":580,"x":680,"height":136},
  "602010503_сущ_мз":{"width":104,"y":104,"x":208,"height":104},
  "602010503_план_мз":{"width":104,"y":104,"x":0,"height":104},
  "602010503_рек_мз":{"width":104,"y":104,"x":104,"height":104},
  "602010504_рек_фз":{"width":136,"y":716,"x":816,"height":136},
  "602010502_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010503_сущ_рз":{"width":118,"y":326,"x":590,"height":118},
  "602010503_план_фз":{"width":136,"y":716,"x":136,"height":136},
  "602010502_ликв_рз":{"width":118,"y":208,"x":680,"height":118},
  "602010503_рек_фз":{"width":136,"y":716,"x":272,"height":136},
  "602010502_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010502_сущ_рз":{"width":118,"y":326,"x":118,"height":118},
  "602010501_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010503_ликв_рз":{"width":118,"y":326,"x":236,"height":118},
  "602010504_ликв_фз":{"width":136,"y":716,"x":544,"height":136},
  "602010505_рек_фз":{"width":136,"y":852,"x":408,"height":136},
  "602010504_ликв_мз":{"width":104,"y":104,"x":312,"height":104},
  "602010503_ликв_фз":{"width":136,"y":716,"x":0,"height":136},
  "602010501_ликв_рз":{"width":118,"y":208,"x":208,"height":118},
  "602010505_рек_мз":{"width":104,"y":208,"x":0,"height":104},
  "602010504_план_фз":{"width":136,"y":716,"x":680,"height":136},
  "602010501_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010502_план_фз":{"width":136,"y":580,"x":544,"height":136},
  "602010505_сущ_мз":{"width":104,"y":208,"x":104,"height":104},
  "602010301_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602010301_ликв_рз":{"width":118,"y":0,"x":832,"height":118},
  "602010301_ликв_фз":{"width":136,"y":118,"x":826,"height":136},
  "602010301_план_мз":{"width":104,"y":0,"x":104,"height":104},
  "602010301_план_рз":{"width":118,"y":118,"x":0,"height":118},
  "602010301_план_фз":{"width":136,"y":254,"x":0,"height":136},
  "602010301_рек_мз":{"width":104,"y":0,"x":208,"height":104},
  "602010301_рек_рз":{"width":118,"y":118,"x":118,"height":118},
  "602010301_рек_фз":{"width":136,"y":254,"x":136,"height":136},
  "602010301_сущ_мз":{"width":104,"y":0,"x":312,"height":104},
  "602010301_сущ_рз":{"width":118,"y":118,"x":236,"height":118},
  "602010301_сущ_фз":{"width":136,"y":254,"x":272,"height":136},
  "602010302_ликв_мз":{"width":104,"y":0,"x":416,"height":104},
  "602010302_ликв_рз":{"width":118,"y":118,"x":354,"height":118},
  "602010302_ликв_фз":{"width":136,"y":254,"x":408,"height":136},
  "602010302_план_мз":{"width":104,"y":0,"x":520,"height":104},
  "602010302_план_рз":{"width":118,"y":118,"x":472,"height":118},
  "602010302_план_фз":{"width":136,"y":254,"x":544,"height":136},
  "602010302_рек_мз":{"width":104,"y":0,"x":624,"height":104},
  "602010302_рек_рз":{"width":118,"y":118,"x":590,"height":118},
  "602010302_рек_фз":{"width":136,"y":254,"x":680,"height":136},
  "602010302_сущ_мз":{"width":104,"y":0,"x":728,"height":104},
  "602010302_сущ_рз":{"width":118,"y":118,"x":708,"height":118},
  "602010302_сущ_фз":{"width":136,"y":254,"x":816,"height":136},
  "602031310_ликв_мз":{"width":104,"y":0,"x":0,"height":104},
  "602031310_ликв_рз":{"width":118,"y":0,"x":104,"height":118},
  "602031310_ликв_фз":{"width":136,"y":118,"x":0,"height":136},
  "602031310_план_мз":{"width":104,"y":118,"x":136,"height":104},
  "602031310_план_рз":{"width":118,"y":254,"x":0,"height":118},
  "602031310_план_фз":{"width":136,"y":254,"x":118,"height":136},
  "602031310_рек_мз":{"width":104,"y":390,"x":0,"height":104},
  "602031310_рек_рз":{"width":118,"y":390,"x":104,"height":118},
  "602031310_рек_фз":{"width":136,"y":508,"x":0,"height":136},
  "602031310_сущ_мз":{"width":104,"y":508,"x":136,"height":104},
  "602031310_сущ_рз":{"width":118,"y":644,"x":0,"height":118},
  "602031310_сущ_фз":{"width":136,"y":644,"x":118,"height":136}
}
